const fontFamilies = {
  Helvetica: '"DS Indigo", DSIndigo, Helvetica, Arial, sans-serif',
  MavenPro: '"Maven Pro", Helvetica, Arial, sans-serif',
} as const

export default fontFamilies
